import { IMonarchLanguage, IContribution, ICodeEditorExtensionPoints } from "BuiltInExtensions/Scripts/TFS.Extensions.CodeEditor.Contributions";
import * as SDK_Shim from "VSS/SDK/Shim";

//based on https://dev.azure.com/mseng/AppInsights/_git/MASI-LogAnalyticsUX?path=%2FLogAnalyticsPortalWebRole%2FScripts%2Fdev%2Fplugins%2Fdiscover%2Fcommon%2FKustoLanguageProvider.ts&version=GBmaster

const PromotedOperatorCommandTokens = ["where","count","extend","join","limit","order","project","project-away","project-rename","render","sort","summarize","distinct","take","top","top-nested","top-hitters","union","mvexpand","reduce","evaluate","parse","sample","sample-distinct","make-series","getschema","serialize","invoke"];
const OperatorCommandTokens = ["filter","fork","facet","range","consume","find","search","print","where","count","extend","join","limit","order","project","project-away","project-rename","render","sort","summarize","distinct","take","top","top-nested","top-hitters","union","mvexpand","reduce","evaluate","parse","sample","sample-distinct","make-series","getschema","serialize","invoke"];
const kusto: IMonarchLanguage = {
    name: 'kusto',
    mimeTypes: ['text/kusto'],
    displayName: "window.Kusto",
    defaultToken: "invalid",
    brackets: [ ['[',']','delimiter.square'],
                ['(',')','delimiter.parenthesis'] ],
    wordDefinition: /(-?\d*\.\d\w*)|([^\`\~\!\#\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
    promotedOperatorCommandTokens: PromotedOperatorCommandTokens,
    operatorCommandTokens: OperatorCommandTokens,
    keywords: [
        'by', 'on', 'contains', 'notcontains', 'containscs', 'notcontainscs', 'startswith', 'has', 'matches', 'regex', 'true',
        'false', 'and', 'or', 'typeof', 'int', 'string', 'date', 'datetime', 'time', 'long', 'real', '​boolean', 'bool'
    ],
    operators: ['+', '-', '*', '/', '>', '<', '==', '<>', '<=', '>=', '~', '!~'],
    builtinFunctions: [
        'countof', 'bin', 'extentid', 'extract', 'extractjson', 'floor', 'iif', 'isnull', 'isnotnull', 'notnull', 'isempty',
        'isnotempty', 'notempty', 'now', 're2', 'strcat', 'strlen', 'toupper',
        'tostring', 'count', 'cnt', 'sum', 'min', 'max', 'avg'],
    escapes: /(\\\\|\\"|\\')/,
    tokenizer: {
        root: [
            { include: '@whitespace' },
            { include: '@numbers' },
            { include: '@strings' },
            { include: '@dqstrings' },
            { include: '@literals' },
            { include: '@comments' },
            [/[;,.]/, 'delimiter'],
            [/[()\[\]]/, '@brackets'],
            [/[<>=!%&+\-*/|~^]/, 'operator'],
            [/[\w@#\-$]+/, {
                cases: {
                    '@keywords': 'keyword',
                    '@promotedOperatorCommandTokens': 'keyword',
                    '@operatorCommandTokens': 'keyword',
                    '@operators': 'operator',
                    '@builtinFunctions': 'predefined',
                    '@default': 'identifier',
                }
            }],
        ],
        whitespace: [[/\s+/, 'white']],
        comments: [["\\/\\/+.*", "comment"]],
        numbers: [
            [/0[xX][0-9a-fA-F]*/, 'number'],
            [/[$][+-]*\d*(\.\d*)?/, 'number'],
            [/((\d+(\.\d*)?)|(\.\d+))([eE][\-+]?\d+)?/, 'number']
        ],
        strings: [
            [/'/, { token: 'string.quote', bracket: '@open', next: '@string' }],
        ],
        string: [
            [/[^\\']+/, 'string'],
            [/@escapes/, 'string.escape'],
            [/'/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
        ],
        dqstrings: [
            [/"/, { token: 'string.quote', bracket: '@open', next: '@dqstring' }]
        ],
        dqstring: [
            [/[^\\"]+/, 'string'],
            [/@escapes/, 'string.escape'],
            [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
        ],

        literals: [[/datetime\(\d{4}-\d{2}-\d{2}(\s+\d{2}:\d{2}(:\d{2}(\.\d{0,3})?)?)?\)/, 'number'],
            [/time\((\d+(s(ec(onds?)?)?|m(in(utes?)?)?|h(ours?)?|d(ays?)?)|(\s*(('[^']+')|("[^"]+"))\s*))\)/, 'number'],
            [/guid\([\da-fA-F]{8}-[\da-fA-F]{4}-[\da-fA-F]{4}-[\da-fA-F]{4}-[\da-fA-F]{12}\)/, 'number'],
            [/typeof\((int|string|date|datetime|time|long|real|boolean|bool)\)/, 'number']]
    }
    // Cast to any then IMonarchLanguage because the monarch language type is actually quite 
    // a bit broader than the type definition for it in monaco.d.ts.
    // See https://microsoft.github.io/monaco-editor/monarch.html for the full documentation.
} as any as IMonarchLanguage;

//end of code based on AppInsights repo

SDK_Shim.registerContent("ms.vss-code-web.code-editor-language-kusto", () => {
    return {
        register: function (endpoints: ICodeEditorExtensionPoints) {
            endpoints.registerLanguage({
                extensionPoint: { id: 'Kusto', extensions: ['.csl', '.kusto'] },
                monarchLanguage: kusto,
                configuration: null
            });
        } 
    } as IContribution;
})